/*
 * Card hover-to-play video (animealters)
 * Plays a product card's video while hovered and pauses + rewinds on leave.
 * Cards without a .card__media-video are untouched. Also re-binds cards that
 * Dawn swaps in via the Section Rendering API (collection filtering,
 * pagination, quick add, etc.).
 */
(function () {
  function bindCardVideo(video) {
    if (video.dataset.hoverBound) return;
    video.dataset.hoverBound = 'true';

    var card = video.closest('.card-wrapper') || video.parentElement;
    if (!card) return;

    card.addEventListener('mouseenter', function () {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        // Ignore the AbortError that fires if the pointer leaves mid-load.
        playPromise.catch(function () {});
      }
    });

    card.addEventListener('mouseleave', function () {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {
        /* metadata not ready yet — safe to ignore */
      }
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.card__media-video').forEach(bindCardVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // Re-bind cards injected after initial load.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.card__media-video')) {
          bindCardVideo(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
